<template>
  <section class="lg:py-24 py-12">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <KlaviyoForm />
    </div>
  </section>
</template>

<script>
import KlaviyoForm from "@/components/blog/KlaviyoForm.vue";

export default {
  name: "HomeSignup",
  components: {
    KlaviyoForm,
  },
};
</script>
